import { onboardingQueryKeys as e } from "../onboarding/useOnboardingQueryKeys.mjs";
import { verificationQueryKeys as t } from "./useVerificationQueryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { verificationApi as i } from "@maat/api-main";
import { authQueryKeys as a } from "@maat/store-auth";
//#region src/verification/useSubmitIdentityVerificationMutation.ts
var o = () => {
	let o = r();
	return n({
		mutationFn: i.submitIdentityVerification,
		onSuccess: () => {
			o.invalidateQueries({ queryKey: t.identity() }), o.invalidateQueries({ queryKey: a.state() }), o.invalidateQueries({ queryKey: a.me() }), o.invalidateQueries({ queryKey: e.status() });
		}
	});
};
//#endregion
export { o as useSubmitIdentityVerificationMutation };
